export default __webpack_public_path__ + "static/media/logo-lg.cd13e959.png";